export default __webpack_public_path__ + "static/media/return.d118eb48.svg";